import { render, staticRenderFns } from "./bookings.vue?vue&type=template&id=6c491ca8&scoped=true&"
import script from "./bookings.vue?vue&type=script&lang=js&"
export * from "./bookings.vue?vue&type=script&lang=js&"
import style0 from "./bookings.vue?vue&type=style&index=0&id=6c491ca8&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c491ca8",
  null
  
)

export default component.exports